module.exports = "<div class=\"bc-wrap flex-box flex-just-space\">\n  <setting-section-header [breadcrumbs]=\"breadcrumbs\"></setting-section-header>\n</div>\n\n<div class=\"box\">\n  <h3>Account Details</h3>\n  <account-details [user]=\"editedUser\"></account-details>\n  <hr>\n  <login-change [user]=\"editedUser\" [initialEmail]=\"user.email\"></login-change>\n  <password-change></password-change>\n</div>\n\n<div>\n  <h3>Subscription</h3>\n  <subscription-change [user]=\"user\"></subscription-change>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/profile.html
// module id = ./web/modern/components/settings/profile/profile.html
// module chunks = 0